import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import { NIP19Page } from "./pages/NIP19Page";
import { SpaceEditor } from "./pages/SpaceEditor";
import { Reader } from "./pages/Reader";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        {/* Space editor (logged-in owner) */}
        <Route path="/s/:spaceSlug" element={<SpaceEditor />} />
        <Route path="/s/:spaceSlug/*" element={<SpaceEditor />} />
        {/* Public reader (anonymous) */}
        <Route path="/r/:npub/:spaceSlug" element={<Reader />} />
        <Route path="/r/:npub/:spaceSlug/*" element={<Reader />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
